import styled from 'styled-components';

export const CURuleStyled = styled.div`
  .tabs-container {
    margin-bottom: 16px;
    @media (min-width: 768px) {
      width: fit-content;
    }
  }
  .main-navbar {
    position: sticky;
    top: 0;
    z-index: 10;
    height: 3.5rem;
    background-color: rgb(241, 241, 241);
    display: flex;
    align-items: center;
  }
  .wrap-banner-error {
    margin-bottom: 16px;
    .custom-card-content > div {
      margin-bottom: 0 !important;
    }
    > div > div > div.Polaris-Box {
      padding: 0;
    }
  }

  .Polaris-LegacyTabs__Title::before {
    padding: 1.6px;
  }

  .Polaris-Page__Content {
    padding-top: 0 !important;
  }
`;
